import React from "react";
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import {Pagination} from "..";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import {AutoIncrementer} from "../../../_helpers/AutoIncrementer";
import BootstrapTable from "react-bootstrap-table-next";
import * as uiHelpers from "../../../../app/admin/baskets/BasketsUIHelpers";
import {NoRecordsFoundMessage, PleaseWaitMessage} from "../../../_helpers";
import {paginationOptions} from "../../../_helpers/TablePaginationOptions";

export default function TableLayout({
                                        data,
                                        activePage,
                                        columns
                                    }) {

    const {SearchBar} = Search;

    return (
        <PaginationProvider pagination={paginationFactory({...paginationOptions(data)})}>
            {({paginationProps, paginationTableProps}) => {
                return (
                    <Pagination
                        isLoading={false}
                        paginationProps={paginationProps}
                        page={activePage}
                    >
                        <ToolkitProvider
                            keyField="priority"
                            data={AutoIncrementer(data.data, activePage - 1, data.per_page)}
                            columns={columns}
                            search
                        >
                            {
                                props => (
                                    <div>
                                        <SearchBar {...props.searchProps} />
                                        <hr/>
                                        <BootstrapTable
                                            wrapperClasses="table-responsive"
                                            bordered={false}
                                            classes="table table-head-custom table-vertical-center overflow-hidden"
                                            bootstrap4
                                            defaultSorted={uiHelpers.defaultSorted}
                                            {...paginationTableProps}
                                            {...props.baseProps}
                                        >
                                            <PleaseWaitMessage entities={data.data}/>
                                            <NoRecordsFoundMessage entities={data.data}/>
                                        </BootstrapTable>
                                    </div>
                                )
                            }
                        </ToolkitProvider>
                    </Pagination>
                );
            }}
        </PaginationProvider>

    )
}